import gql from 'graphql-tag';
import { Fragments } from '@shared/api/fragments';

export const linkList = gql`
  query LinkListQuery($businessId: Int!) {
    business: myBusiness(businessId: $businessId) {
      ...Business
      links: channels(filter: TOOLS) {
        ...ToolLinkListItem
      }
    }
  }

  ${Fragments.business.business}
  ${Fragments.tool.link}
`;
